import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { toTitleCase } from "../../../Utils/stringUtls";
import { formatReviewDate } from "./reviewSummaryUtils";

const SignoffOverview = ({ data }) => {
  const {
    sign_off_client_name,
    sign_off_title,
    sign_off_date,
    sign_off_signature,
  } = data;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="6@md">
          <div i2c-grid="grid grid" className="review-summary-gap">
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Client Name"
                value={
                  sign_off_client_name?.length
                    ? toTitleCase(sign_off_client_name)
                    : "-"
                }
              />
            </div>
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Client Title"
                value={
                  sign_off_title?.length ? toTitleCase(sign_off_title) : "-"
                }
              />
            </div>
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Signature Date"
                value={
                  sign_off_date?.length ? formatReviewDate(sign_off_date) : "-"
                }
              />
            </div>
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text">Signature</div>
          {sign_off_signature?.length ? (
            <img
              className="signature-image"
              src={sign_off_signature?.length ? sign_off_signature : ""}
              alt="Signature"
            />
          ) : (
            <div className="overview-val-text">-</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default SignoffOverview;
